import { createReducer, on } from '@ngrx/store';
import { FeedbackActions } from './feedback.actions';
import { FeedbackState, initialFeedbackState } from './models/feedback-state.models';

export const feedbackReducer = createReducer(
  initialFeedbackState,

  // Submit feedback
  on(FeedbackActions.submitFeedback, (state): FeedbackState => ({
    ...state,
    submitting: true,
    submitError: null
  })),
  on(FeedbackActions.submitFeedbackSuccess, (state, { feedback }): FeedbackState => ({
    ...state,
    lastSubmittedFeedback: feedback,
    submitting: false,
    submitError: null,
    // Add to history if it exists
    feedbackHistory: [feedback, ...state.feedbackHistory]
  })),
  on(FeedbackActions.submitFeedbackFailure, (state, { error }): FeedbackState => ({
    ...state,
    submitting: false,
    submitError: error
  })),

  // Dismiss feedback
  on(FeedbackActions.dismissFeedback, (state): FeedbackState => ({
    ...state,
    dismissing: true,
    dismissError: null
  })),
  on(FeedbackActions.dismissFeedbackSuccess, (state): FeedbackState => ({
    ...state,
    dismissing: false,
    dismissError: null
  })),
  on(FeedbackActions.dismissFeedbackFailure, (state, { error }): FeedbackState => ({
    ...state,
    dismissing: false,
    dismissError: error
  })),

  // Load feedback history
  on(FeedbackActions.loadFeedbackHistory, (state, { skip, limit }): FeedbackState => ({
    ...state,
    historyLoading: true,
    historyError: null,
    historySkip: skip ?? state.historySkip,
    historyLimit: limit ?? state.historyLimit
  })),
  on(FeedbackActions.loadFeedbackHistorySuccess, (state, { feedbackList, hasMore }): FeedbackState => ({
    ...state,
    feedbackHistory: state.historySkip === 0 ? feedbackList : [...state.feedbackHistory, ...feedbackList],
    historyLoading: false,
    historyError: null,
    historyHasMore: hasMore
  })),
  on(FeedbackActions.loadFeedbackHistoryFailure, (state, { error }): FeedbackState => ({
    ...state,
    historyLoading: false,
    historyError: error
  })),

  // Reset state
  on(FeedbackActions.resetFeedbackState, (): FeedbackState => ({
    ...initialFeedbackState
  })),

  // Clear errors
  on(FeedbackActions.clearErrors, (state): FeedbackState => ({
    ...state,
    submitError: null,
    dismissError: null,
    historyError: null
  }))
);
